import classes from './ChatWidget.module.scss'
import { formatChatDate, formatChatMoney } from './chatFormatters'
import { ChatBasketProposal, ChatBasketProposalLine } from './types'

interface Props {
  proposal: ChatBasketProposal
}

/** Satırın adet metni: ekleme adedi, düzenlemede önceki → yeni adet ya da "çıkarılacak" (Faz-31). */
function quantityText(op: string, line: ChatBasketProposalLine): string {
  if (op === 'remove' || op === 'clear' || (op === 'setQty' && line.quantity === 0)) {
    return `${line.previousQuantity ?? line.quantity} adet · çıkarılacak`
  }
  if (op === 'setQty' && typeof line.previousQuantity === 'number') {
    return `${line.previousQuantity} → ${line.quantity} adet`
  }
  return `${line.quantity} adet`
}

/**
 * Sepet önerisinin özet kartı (Faz-30 ekleme, Faz-31 düzenleme, Faz-32 sipariş tekrarı). SALT OKUNUR bir onay
 * belgesidir: adet burada değiştirilmez (yanlışsa "Vazgeç" ve yeniden yazılır). Onay butonları kartın altındaki
 * StepForm'dan gelir; geçmişte form düştüğü için kart butonsuz görünür (ADR-014). Fiyatı sunucu verir; düzenleme
 * önerisinde fiyat yoktur. Sipariş tekrarı kartı sipariş numarası ve tarihiyle başlar.
 */
export default function BasketProposalCard({ proposal }: Props) {
  // Sipariş tekrarı da sepete EKLER (Faz-32).
  const adds = proposal.op === 'add' || proposal.op === 'reorder'
  const excludedTitle = adds ? 'Eklenemeyenler' : 'Değiştirilemeyenler'
  const moreLineCount = proposal.moreLineCount ?? 0

  return (
    <div className={classes.basketProposal} aria-label='Sepet önerisi'>
      {proposal.orderNo && (
        <div className={classes.basketProposalOrder}>
          Sipariş {proposal.orderNo}
          {proposal.orderDate ? ` · ${formatChatDate(proposal.orderDate)}` : ''}
        </div>
      )}
      {proposal.lines.length > 0 && (
        <ul className={classes.basketProposalLines}>
          {proposal.lines.map((line, index) => (
            <li key={`${line.code}-${line.companyId ?? ''}-${index}`} className={classes.basketProposalLine}>
              <div className={classes.basketProposalMain}>
                <span className={classes.basketProposalName}>{line.name || line.code}</span>
                <span className={classes.basketProposalCode}>{line.code}</span>
              </div>
              <div className={classes.basketProposalMeta}>
                <span className={classes.basketProposalQty}>{quantityText(proposal.op, line)}</span>
                {typeof line.unitPrice === 'number' && line.unitPrice > 0 && (
                  <span className={classes.basketProposalPrice}>{formatChatMoney(line.unitPrice, line.currency)}</span>
                )}
              </div>
              {line.note && <div className={classes.basketProposalNote}>{line.note}</div>}
            </li>
          ))}
        </ul>
      )}
      {moreLineCount > 0 && <div className={classes.basketProposalMore}>ve {moreLineCount} kalem daha</div>}
      {proposal.excluded.length > 0 && (
        <div className={classes.basketProposalExcluded}>
          <span className={classes.basketProposalExcludedTitle}>{excludedTitle}</span>
          <ul>
            {proposal.excluded.map(item => (
              <li key={`${item.name}-${item.reason}`}>
                {item.name}: {item.note}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
